import http from '@/plugins/http'
import { PREFIX_SOPERATION_API, PREFIX_CZJC_API } from '@/service'
const api = {
  cms: '//cms.cekid.com/publish/999/evaluate-config.json',
  publish: PREFIX_SOPERATION_API + 'comment/publishComment.do', // 发布评价
  modifyComment: PREFIX_SOPERATION_API + 'comment/editComment4YuEr.do', // 修改评价
  del: PREFIX_SOPERATION_API + 'comment/del.do', // 删除评价
  detail: PREFIX_SOPERATION_API + 'comment/detail.do', // 评价详情
  getCommentLabelList: PREFIX_SOPERATION_API + 'comment/getCommentLabelList.do', // 获取标签列表
  getCommentConfiguration:
    PREFIX_CZJC_API + 'comment/getPublishCommentConfiguration.do' // 获取评价配置
}

export default {
  namespaced: true,
  actions: {
    async getCmsData() {
      const res = await http.get(`${api.cms}`)
      return res.data
    },
    async publish(context, payload) {
      const res = await http.post(`${api.publish}`, {
        param: JSON.stringify(payload)
      })
      return res
    },
    async modifyComment(context, payload) {
      const res = await http.post(`${api.modifyComment}`, {
        param: JSON.stringify(payload)
      })
      return res
    },
    async delate(context, payload) {
      const res = await http.post(`${api.del}`, payload)
      return res
    },
    async getDetail(context, payload) {
      const res = await http.get(`${api.detail}`, payload)
      return res
    },
    async getCommentLabelList(context, payload) {
      const res = await http.get(`${api.getCommentLabelList}`, payload)
      return res.data || []
    },
    async getCommentConfiguration(context, payload) {
      const res = await http.get(`${api.getCommentConfiguration}`, payload)
      return res.data || {}
    }
  }
}
